import React, { useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core'
import { juridicalPersons } from '../../../../store/slices'
import { useAppDispatch, useAppSelector } from '../../../../store'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { navLinksOrganization, validation } from '../../../../services'
import { Field, Form, Formik } from 'formik'
import { JuridicalPersonUpdateProps } from '../../../../store/types'
import { CheckboxWithLabel, TextField } from 'formik-material-ui'

interface BusinessUnitEditPageProps {
    match: {
        params: {
            id: string
        }
    }
}

export function JuridicalPersonEditPage(props: BusinessUnitEditPageProps): JSX.Element {
    useEffect(() => {
        dispatch(juridicalPersons.actions.fetch())
    }, [])

    const dispatch = useAppDispatch()
    const history = useHistory()
    const entity = useAppSelector((state) => juridicalPersons.selectors.selectById(state, props.match.params.id))
    const initialValues: JuridicalPersonUpdateProps = entity ? entity : {
        id: '',
        iri: '',
        name: '',
        longName: '',
        juridicalAddress: '',
        address: '',
        email: '',
        phone: '',
        ogrn: '',
        inn: '',
        chestnyZnak: false
    }

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
                dispatch(juridicalPersons.actions.update(values))
                    .then(unwrapResult)
                    .then(() => {
                        history.goBack()
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksOrganization}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Редактирование Юр. лица'}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Короткое название"
                                        name="name"
                                        fullWidth
                                        validate={validation.required}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Полное название"
                                        name="longName"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Фактический адрес"
                                        name="address"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Юридический адрес"
                                        name="juridicalAddress"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Email"
                                        name="email"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Телефон"
                                        name="phone"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="ОГРН"
                                        name="ogrn"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="ИНН"
                                        name="inn"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={CheckboxWithLabel}
                                        Label={{ label: 'Честный знак' }}
                                        name="chestnyZnak"
                                        type="checkbox"
                                    />
                                </Grid>
                            </Grid>
                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}